import { render, staticRenderFns } from "./ShowPrint.vue?vue&type=template&id=0b632f67&scoped=true"
import script from "./ShowPrint.vue?vue&type=script&lang=js"
export * from "./ShowPrint.vue?vue&type=script&lang=js"
import style0 from "./ShowPrint.vue?vue&type=style&index=0&id=0b632f67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b632f67",
  null
  
)

export default component.exports